import styled from 'styled-components'

const Link = styled.div`
  display: inline-block;
  color: #428bca;
  font-family: 'Gotham-Medium';
  font-size: 16px;
  line-height: 36px;
  text-decoration: underline;
`

export default Link



// WEBPACK FOOTER //
// ./src/lib/typography/Link.jsx